// extracted by mini-css-extract-plugin
export default {"category":"Categories_category__lbjGG","header":"Categories_header__rpHeG","title":"Categories_title__2xBwI"};